import "./style.scss";
import SidebarCollapse from "../../../app/SidebarCollapse";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { EditableProps } from "../../editableProps";
import Toggle from "@builder/components/general/Toggle";
import { getBackdropToggle, getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { updateNodeProperty } from "@builder/store/slices/BuilderSlice/builderSlice";
import { PopupAlignment, PopupNode } from "@common/build/types";
import RadioInputAlt from "@builder/components/general/RadioInputAlt";
import { useTranslation } from "react-i18next";

const Backdrop: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const node = useAppSelector(getSelectedNode) as PopupNode;
    const { t } = useTranslation();

    const backdropToggle = useAppSelector(getBackdropToggle);
    const backdropCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["backdropClose"], value: checked }));
    };

    const externalButtonCallback = (checked: boolean) => {
        dispatch(updateNodeProperty({ propertyPath: ["closeButton", "active"], value: checked }));
    };

    const popupAlignment = node.alignment;
    const popupAlignmentOptions: { value: PopupAlignment; src: string; tooltip: string }[] = [
        { value: PopupAlignment.LEFT, src: "./align-start.svg", tooltip: t("generalComponents.radioInputAlt.Left") },
        { value: PopupAlignment.CENTER, src: "./align-center.svg", tooltip: t("generalComponents.radioInputAlt.Center") },
        { value: PopupAlignment.RIGHT, src: "./align-end.svg", tooltip: t("generalComponents.radioInputAlt.Right") }
    ];
    const popupAlignmentCallback = (option: { value: PopupAlignment; src: string }) => {
        dispatch(updateNodeProperty({ propertyPath: ["alignment"], value: option.value }));
    };

    return (
        <SidebarCollapse title="Backdrop" parent={parent}>
            <Toggle label="Close popup on click?" checked={backdropToggle || false} callback={backdropCallback} />
            <Toggle label="External close button" checked={node.closeButton?.active || false} callback={externalButtonCallback} />
            <RadioInputAlt
                title={t("generalComponents.radioInputAlt.Popup Alignment")}
                options={popupAlignmentOptions}
                callback={popupAlignmentCallback}
                getSrc={option => option.src}
                isChecked={option => option.value === popupAlignment}
                getTooltip={option => option.tooltip}
            />
        </SidebarCollapse>
    );
};

export default Backdrop;
